import { Role } from './roles';

export enum CustomAccessResorces {
  Limits = 'limits',
  Commissions = 'commissions',
  OrderAdjustments = 'order_adjustments',
  MethodLogos = 'method_logos',
}

export const CUSTOM_ACCESS_RESOURCES_PROHIBITED_ROLES = {
  [CustomAccessResorces.Limits]: [Role.Payment],
  [CustomAccessResorces.Commissions]: [Role.Payment],
  [CustomAccessResorces.OrderAdjustments]: [Role.FinanceLead, Role.Finance],
  [CustomAccessResorces.MethodLogos]: [Role.Payment],
};
